import {css} from "@panda/css";

import {InputField, PhoneFieldControlled} from "@pg-design/rhf-components-module";
import {OFFER_TEST_IDS} from "@pg-mono/test-ids";
import {EmailInputWithVerification, EmailVerificationResponse} from "@pg-rp/email-with-verification";

import {useAppSelector} from "../../../store/hooks";
import {useGetUserProfileQuery} from "../../../user/api/get_user_profile";

interface Props {
    verificationData: EmailVerificationResponse | undefined;
    verificationTrigger: (email: string | null) => void;
}

export const LeadFormUserDataFields = (props: Props) => {
    const {verificationTrigger, verificationData} = props;
    const codes = useAppSelector((state) => state.variables.data?.country_codes);
    const {data: userProfile} = useGetUserProfileQuery();

    return (
        <div className={userDataWrapper}>
            <InputField name="name" placeholder="Imię i nazwisko" dataTestId={OFFER_TEST_IDS.LEAD_FORM.FORM_NAME_INPUT} />
            <EmailInputWithVerification
                verificationData={verificationData}
                verificationTrigger={verificationTrigger}
                dataTestId={OFFER_TEST_IDS.LEAD_FORM.FORM_EMAIL_INPUT}
            />
            <PhoneFieldControlled
                name="phone"
                codes={codes ?? []}
                placeholder="Numer telefonu"
                maxMenuHeight={200}
                dataTestId={OFFER_TEST_IDS.LEAD_FORM.FORM_PHONE_INPUT}
                disabled={!!userProfile?.phone}
            />
        </div>
    );
};

const userDataWrapper = css({
    display: "flex",
    flexDirection: "column",
    gap: 1,
    mb: 3
});
